// extracted by mini-css-extract-plugin
module.exports = {"pointer":"action_pointer__w-vVU","pointerEvent":"action_pointerEvent__2gT-W","svgExternal":"action_svgExternal__11txD","custom-dropdown":"action_custom-dropdown__2WREK"};